export const getLanguageFromLocalStorage = () => {
  let language = localStorage.getItem("user-language") || "en" // moze da bude undefined u stringu, srediti
  if (language === "undefined") {
    localStorage.setItem("user-language", "en")
    language = "en"
  }

  return language
}
